import { CalendlyButton } from "@/components/landing/CalendlyButton";
import { Reveal } from "@/components/landing/Reveal";

export const FinalCTA = () => (
  <section
    id="get-started"
    data-testid="final-cta-section"
    className="relative bg-navy-900 text-warm-neutral py-28 md:py-40 overflow-hidden"
  >
    <div className="grain-overlay" aria-hidden="true" />
    <div className="container-page relative z-10">
      <Reveal>
        <h2 className="font-heading font-semibold text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl">
          Your Books Should Help You Run Your Business,{" "}
          <span className="italic font-normal text-warm-accent">
            Not Leave You Guessing
          </span>
        </h2>
        <p className="font-body text-base sm:text-lg leading-relaxed text-warm-neutral/75 max-w-xl mt-8">
          Let&rsquo;s talk about what is happening and determine the right next
          step.
        </p>
        <div className="mt-10">
          <CalendlyButton testId="final-cta-button" variant="light" size="lg">
            Schedule a Free 30-Minute Bookkeeping Consultation
          </CalendlyButton>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
